import * as React from "react";
const SvgFiRrEarthAfrica = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-earth-africa_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12a10 10 0 0 1 4.477-8.332l1.247 1.091A.8.8 0 0 1 8 5.367v.826c0 .446.362.808.808.808h.726c.305 0 .605-.083.867-.24l1.546-.928a.83.83 0 0 1 1.01.124l.801.801a.83.83 0 0 1 .242.585v.831c0 .457-.37.827-.827.827H10.54c-.352 0-.697.104-.99.3l-1.756 1.17a1.78 1.78 0 0 0-.795 1.485v1.045a2 2 0 0 0 2 2h1.427c.337 0 .63.229.712.556l.693 2.774a.89.89 0 0 0 .859.671h.807a.88.88 0 0 0 .759-.43l2.495-4.159c.161-.269.247-.577.247-.891v-1.303c0-.459-.182-.9-.507-1.224l-.993-.993h2.257c.796 0 1.559-.316 2.121-.879l1.235-1.235a9.9 9.9 0 0 1 .886 4.114c0 5.514-4.486 10-10 10z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-earth-africa_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEarthAfrica;
